import React, { useEffect, useState, useRef } from 'react'
import IconRemove from '../svg/IconRemove'
import IconAdd from '../svg/IconAdd'
import authStores from "../../contexts/AuthProvider";
import Http from '../../api/Http';
import { CART_API_URL, HOME_API_URL } from '../../api/path';
import { useMutation } from "react-query";
import { useSnackbar } from "notistack";

const QuntityHandler = ({ count, productId, setQuntityCount, setId, rateId, maxQuantity, onAdjust, onBurstStart, onBurstSettled }) => {
    const { enqueueSnackbar } = useSnackbar();
    const [totalCount, setTotalCount] = useState();
    const [localCount, setLocalCount] = useState(count);
    const countRef = useRef(count);
    const pendingRef = useRef(0);
    const runningRef = useRef(false);
    const maxQty = maxQuantity === undefined || maxQuantity === null ? null : Number(maxQuantity);
    const atMax = maxQty !== null && Number.isFinite(maxQty) && localCount >= maxQty;

    const showError = (error) => {
        const errorMessage = error?.response?.data?.message;
        if (errorMessage) {
            enqueueSnackbar(errorMessage, {
                variant: "error",
                anchorOrigin: { vertical: "top", horizontal: "right" },
                autoHideDuration: 2000,
            });
        }
    };
    const { sessionId, isAuthenticated } = authStores((state) => ({
        sessionId: state.sessionId,
        isAuthenticated: state.isAuthenticated
    }));

    const { mutateAsync: addToCart } = useMutation(
        async (data) => {
            return await isAuthenticated ? Http.post(CART_API_URL.addCart, { product_id: data, rate_id: rateId }) : Http.post(HOME_API_URL.addCart, { sessionId: sessionId, product_id: data, rate_id: rateId });
        }
    );

    const { mutateAsync: removeToCart } = useMutation(
        async (data) => {
            return await isAuthenticated ? Http.post(CART_API_URL.removeCart, { product_id: data, rate_id: rateId }) : Http.post(HOME_API_URL.removeCart, { sessionId: sessionId, product_id: data, rate_id: rateId });
        }
    );

    const flushQuantity = async () => {
        if (runningRef.current) return;
        runningRef.current = true;
        let failed = false;
        try {
            while (pendingRef.current !== 0) {
                const step = pendingRef.current > 0 ? 1 : -1;
                pendingRef.current -= step;
                try {
                    if (step > 0) {
                        await addToCart(productId);
                    } else {
                        const { data } = await removeToCart(productId);
                        setTotalCount(data?.cartLength);
                    }
                } catch (error) {
                    failed = true;
                    pendingRef.current = 0;
                    showError(error);
                    break;
                }
            }
        } finally {
            runningRef.current = false;
            if (!failed && pendingRef.current !== 0) {
                flushQuantity();
                return;
            }
            onBurstSettled?.(failed);
        }
    };

    const queueQuantity = (delta) => {
        const next = countRef.current + delta;
        if (delta > 0 && maxQty !== null && Number.isFinite(maxQty) && countRef.current >= maxQty) {
            enqueueSnackbar(`Only ${maxQty} available`, {
                variant: "warning",
                anchorOrigin: { vertical: "top", horizontal: "right" },
                autoHideDuration: 2000,
            });
            return;
        }
        // Cart line minimum is 1; further remove is delete (handled by parent / API).
        if (delta < 0 && next < 0) return;
        const wasIdle = pendingRef.current === 0 && !runningRef.current;
        countRef.current = next;
        setLocalCount(Math.max(0, next));
        onAdjust?.(delta);
        pendingRef.current += delta;
        if (wasIdle) onBurstStart?.();
        flushQuantity();
    };

    useEffect(() => {
        const currentUrl = window.location.pathname;
        if (totalCount == 0) {
            if (currentUrl == '/checkout') {
                window.history.back();
            }
        }
    }, [totalCount]);

    // New cart line (React remount / product change) — always reset local qty.
    useEffect(() => {
        pendingRef.current = 0;
        runningRef.current = false;
        const next = Math.max(0, Number(count) || 0);
        countRef.current = next;
        setLocalCount(next);
    }, [productId, rateId]);

    useEffect(() => {
        if (pendingRef.current !== 0 || runningRef.current) return;
        const next = Math.max(0, Number(count) || 0);
        countRef.current = next;
        setLocalCount(next);
    }, [count]);

    useEffect(() => {
        setQuntityCount(localCount)
        setId(productId)
    }, [localCount]);

    return (
        <div className='quntity-handler inline-flex bg-gray-light'>
            <button className='w-8 h-8 flex items-center justify-center border-none outline-none group/handlersub hover:bg-dark' onClick={() => queueQuantity(-1)}>
                <IconRemove className="w-5 h-5  text-gray-dark group-hover/handlersub:!text-white" />
            </button>
            <input type="button" value={localCount} className="w-8 h-8 text-sm font-600 text-dark" />
            <button
                className='w-8 h-8 flex items-center justify-center border-none outline-none group/handleradd hover:bg-dark disabled:opacity-40 disabled:cursor-not-allowed'
                disabled={atMax}
                onClick={() => queueQuantity(1)}
            >
                <IconAdd className="w-5 h-5 text-gray-dark group-hover/handleradd:!text-white" />
            </button>
        </div>
    )
}

export default QuntityHandler